import { createContext } from 'react'
import { EditPanelAction } from '../types/action'

export type EditPanelActionContextProps = {
    performAction: <T>(action: EditPanelAction, value: T) => Promise<void>
}

export const EditPanelActionContext = createContext({} as EditPanelActionContextProps)
